import React from "react";
import useProductModal from "@src/store/reducers/CartSlice/hooks/useProductModal";
import ProductModalLoadingOverlay from "./ProductModalLoadingOverlay";

/**
 * Fallback Suspense du chunk ProductModal : overlay uniquement si une ouverture
 * est en cours (évite un flash loader au preload listing).
 */
const ProductModalSuspenseFallback = () => {
  const openProduct = useProductModal();
  if (!openProduct) return null;
  return <ProductModalLoadingOverlay />;
};

export default ProductModalSuspenseFallback;
